import type {Resource} from '@igp/shared/access-control';

import {useAccessControlContext} from './AccessControlProvider';

export function useBoAgentAccessCheck(resource: Resource) {
    const {claims} = useAccessControlContext();

    return resource.rules.validate(claims);
}
